import axiosClient from "../../shared/components/requests/axiosCLient";
import { API_URLS } from "../../shared/constants/constants";

export const getIndustry = (slug) => {
  const url = API_URLS.industry(slug);
  return axiosClient.get(url);
};

export const getIndustryTable = () => {
  const url = API_URLS.industryTable;
  return axiosClient.get(url);
};

export const getIndustryCategory = () => {
  const url = API_URLS.industryCategory;
  return axiosClient.get(url);
};
